var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { OnnxNode } from '../node';
export class EluNode extends OnnxNode {
    constructor(attributes, inputs, outputs, constants, onnxVersion, mode) {
        super(attributes, inputs, outputs, constants, onnxVersion, mode);
        this.alpha = this.getAttributeFloat('alpha') || 1.0;
    }
    forward(inputs) {
        return __awaiter(this, void 0, void 0, function* () {
            const tensor = inputs[0];
            const below = tensor.clip(undefined, 0);
            const above = tensor.clip(0, undefined);
            const belowExp = below.exp();
            below.delete();
            const b = belowExp.addMultiplyScalar(this.alpha, -this.alpha);
            belowExp.delete();
            const result = b.add(above);
            b.delete();
            above.delete();
            return [result];
        });
    }
    delete() { }
    getType() {
        return 'Elu';
    }
}
//# sourceMappingURL=elu.js.map